import styled from "@emotion/styled";

import { sizeToken } from "../../Internals/ThemeProvider/CandyTheme/ThemeBuilder/ICandyTheme";

export const Root = styled("div")({
    marginBottom: sizeToken(5),
});
